import { useMutation, useQueryClient } from "@tanstack/react-query";
import { buildMonographPt } from "../api/monograph";

function invalidatePhase5(qc: ReturnType<typeof useQueryClient>, projectId: string) {
  qc.invalidateQueries({ queryKey: ["project", projectId] });
  qc.invalidateQueries({ queryKey: ["extractions", projectId] });
  qc.invalidateQueries({ queryKey: ["extractions-summary", projectId] });
  qc.invalidateQueries({ queryKey: ["monograph", projectId] });
}

export function useBuildMonographPt(projectId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => buildMonographPt(projectId),
    onSuccess: () => invalidatePhase5(qc, projectId),
  });
}
